import React from 'react'

import { useTheme } from '@emotion/react'

import { useHelpTextId } from '../../hooks/useHelpTextId'
import ArcadeHelpText, { ArcadeHelpTextComponentProps } from '../Input/ArcadeHelpText'
import { HelpTextProps, InputCard } from '../InputCard/InputCard'
import RadioCell, { RadioCellProps } from '../RadioCell/RadioCell'

export interface RadioInputCardProps extends RadioCellProps, ArcadeHelpTextComponentProps {
  cellProps?: Omit<RadioCellProps['cellProps'], HelpTextProps>
}

export default React.forwardRef<HTMLDivElement, RadioInputCardProps>((props, ref) => {
  const { spacing } = useTheme()
  const { helpText, HelpTextIcon, isInvalid, errorText, disabled, disabledText, ...restProps } = props
  const helpTextId = useHelpTextId({ helpText, errorText, disabledText })

  return (
    <>
      <InputCard>
        <RadioCell
          headerSpacing={spacing.xxs}
          ref={ref}
          disabled={disabled}
          cellProps={{ helpTextId }}
          {...restProps}
        />
      </InputCard>
      <ArcadeHelpText
        helpTextId={helpTextId}
        helpText={helpText}
        HelpTextIcon={HelpTextIcon}
        isInvalid={isInvalid}
        errorText={errorText}
        disabled={disabled}
        disabledText={disabledText}
      />
    </>
  )
})
